import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Redirect } from 'react-router-dom'

import {
	setBill,
	getBill,
	getEmail,
	getUnsubscribeBill,
} from '../../redux/slices/userSlice'
import * as queryString from 'query-string'

import './styles.scss'

const SuccessScreen = () => {
	const { search } = useLocation()
	const dispatch = useDispatch()

	const [isActive, setIsActive] = useState(false)
	const isAuthorized = useSelector(getEmail)
	const unsubscribeBill = useSelector(getUnsubscribeBill)

	let isBill = false

	const data = queryString.parse(search)
	if (data.billed) {
		dispatch(setBill({ value: data.billed, alternativePurchase: -1 }))
		isBill = data.billed
	} else {
		isBill = useSelector(getBill)
	}

	useEffect(() => {
		setTimeout(() => {
			setIsActive(true)
		}, 350)
	}, [])

	return !(isBill || unsubscribeBill || isAuthorized) ? (
		<Redirect to="/" />
	) : (
		<div className={`success ${isActive ? 'success--active' : ''}`}>
			<h4 className="success__title">Success!</h4>
			<p className="success__description">
				You&apos;ve got premium access to app.
				<br />
				Download right now!
			</p>
			<h4 className="success__title">Instruction</h4>
			<div className="success-step">
				<p className="step__title">Follow by the link to get Refine app</p>
				{/* <p className="step__description">
					Follow by the link to get Refine app
				</p> */}
			</div>
			<div className="download-links">
				<a
					href="https://refineapp.onelink.me/0MkB/38141eb"
					className="link"
					target="_blank"
					rel="noreferrer"
				>
					<img
						className="link-image"
						src="/images/success/download-apple.png"
						alt="download-apple"
					/>
				</a>
				<a
					href="https://animafy.onelink.me/jcFx/b1ab92ad"
					className="link"
					target="_blank"
					rel="noreferrer"
				>
					<img
						className="link-image"
						src="/images/success/download-google.png"
						alt="download-google"
					/>
				</a>
			</div>
			{/* <div className="success-step">
				<p className="step__title">Step 2</p>
				<p className="step__description">Next step is your activation key</p>
				<img
					src="/images/success/step2.png"
					className="step__image"
					alt="step"
				/>
			</div> */}
		</div>
	)
}

export { SuccessScreen }
